import { sendError } from '@shared/api/services/sendError';

export default class GlobalErrorHandler {
  constructor(global, VuexStore) {
    this.isDev = process.env.NODE_ENV !== 'production';
    this.global = global;
    this.store = VuexStore;
    this.handlers = [setErrorInStore, printErrorToConsole, sendErrorToServer];
  }

  init() {
    this.handlers.forEach((handler) => {
      global.addEventListener('error', handler.bind(this));
      global.addEventListener('unhandledrejection', handler.bind(this));
    });
  }

  static vueErrorHandler(msg) {
    window.dispatchEvent(new ErrorEvent('error', { error: msg }));
  }
}

function setErrorInStore(errorEvent) {
  const error = errorEvent.error || errorEvent.reason;
  if (!error || error.suppress) return;
  this.store.dispatch('setError', error); // Store is passed to constructor
}

function printErrorToConsole(errorEvent) {
  if (!this.isDev) return;
  const error = errorEvent.error || errorEvent.reason;
  console.error(error);
}

function sendErrorToServer(errorEvent) {
  try {
    const error = errorEvent.error || errorEvent.reason;
    // Sende nichts, falls kein Error oder Netzwerkfehler
    if (!error || error.message === 'Network Error') return;
    // ... oder vom Server gemeldeter Fehler
    if (error.response && error.response.status >= 400) return;

    let userData = {};
    if (this.store.state.app === 'recr') {
      // Sende immer die recruiter Infos mit (falls gesetzt)
      userData =
        this.store.state.recruiterInfo &&
        Object.keys(this.store.state.recruiterInfo).length > 0
          ? this.store.state.recruiterInfo
          : {};
      // Falls Projekt schon ausgewählt ist, schicke die proj_id mit
      userData.project =
        this.store.state.project &&
        Object.keys(this.store.state.project).length > 0
          ? this.store.state.project.proj_id
          : null;
      // Falls Profil schon ausgewählt ist, schicke die prof_id mit
      userData.profile =
        this.store.state.profile &&
        Object.keys(this.store.state.profile).length > 0
          ? this.store.state.profile.prof_id
          : null;
      // Falls ein Tool aktiv ist, schicke Tools.activeTool mit
      userData.tool =
        this.store.state.Tools && this.store.state.Tools.activeTool
          ? this.store.state.Tools.activeTool
          : null;
    } else if (this.store.state.app === 'user') {
      // User Data immer mitschicken (projekt Id ist immer drin)
      userData =
        this.store.state.userData &&
        Object.keys(this.store.state.userData).length > 0
          ? this.store.state.userData
          : {};
      // Falls Profil schon ausgewählt ist, schicke die prof_id mit
      userData.profile =
        this.store.state.activeProfile &&
        Object.keys(this.store.state.activeProfile).length > 0
          ? this.store.state.activeProfile.id
          : null;
    }

    const data = {
      client: this.store.state.app,
      userAgent: window.navigator.userAgent,
      url: window.location.href,
      errMessage: error.message,
      errStack: error.stack,
      userInfo: userData,
    };
    sendError(data);
  } catch (e) {
    console.log(e);
  }
}
